import { AnimatePresence, motion } from 'framer-motion';

export default function FadeIn({
  loaded,
  children,
  delay,
  duration,
  className,
  disable,
  initial,
  mode,
}: {
  loaded: boolean;
  children: any;
  delay?: number;
  duration?: number;
  className?: string;
  disable?: boolean;
  initial?: boolean;
  mode?: string;
}) {
  if (disable) {
    return <div className={className}>{children}</div>;
  }

  if (initial) {
    return (
      <AnimatePresence initial={true} mode={(mode as any) || 'popLayout'}>
        <motion.div
          animate={{ opacity: loaded ? 1 : 0 }}
          className={className}
          initial={{ opacity: 0 }}
          transition={{ duration: duration ?? 0.2, delay: delay ?? 0 }}
        >
          {children}
        </motion.div>
      </AnimatePresence>
    );
  }

  return (
    <motion.div
      animate={{ opacity: loaded ? 1 : 0 }}
      className={className}
      initial={{ opacity: 0 }}
      transition={{ duration: duration ?? 0.2, delay: delay ?? 0 }}
    >
      {children}
    </motion.div>
  );
}
